import React, { useContext } from 'react'
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom'
import Home from './pages/Home'
import Conformities from './pages/Conformities'
import ConformityStats from './pages/ConformityStats'
import Contact from './pages/Contact'
import Formalities from './pages/Formalities'
import FormalitiesMonitoring from './pages/FormalitiesMonitoring'
import LegalNotices from './pages/LegalNotices'
import FreeAnswers from './pages/FreeAnswers'
import LastSubmits from './pages/FreeAnswers/LastSubmits'
import { AbilityContext } from './contexts/abilityContext'

const BackOfficeRouting = (): JSX.Element => {
  const ability: any = useContext(AbilityContext)

  return (
    <Router basename="/admin2/v2">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/conformities" element={<Conformities />} />
        {ability.can('overview', 'Conformity') && (
          <Route path="/conformities/stats" element={<ConformityStats />} />
        )}
        <Route path="/contacts">
          <Route index element={<div>404</div>} />
          <Route path=":contactId" element={<Navigate to="resume" />} />
          <Route path=":contactId/:tabKey" element={<Contact />} />
          <Route path=":contactId/:tabKey/:tabItemId" element={<Contact />} />
        </Route>
        <Route path="/formalities" element={<Formalities />} />
        {ability.can('manage', 'LegalFormality') && (
          <Route
            path="/formalities/monitoring"
            element={<FormalitiesMonitoring />}
          />
        )}
        {ability.can('read', 'LegalFormality') && (
          <Route path="/legal_notices" element={<LegalNotices />} />
        )}
        <Route path="/free-answers" element={<FreeAnswers />} />
        <Route path="/free-answers/last-submits" element={<LastSubmits />} />
        <Route path="*" element={<div>404</div>} />
      </Routes>
    </Router>
  )
}

export default BackOfficeRouting
